// reducer.js
import {
  SET_VALUE_ModeleSouscription,
  SET_TYPE_ModeleSouscription,
  SET_CURRENT_PAGE_ModeleSouscription,
  SET_ORDER_ModeleSouscription,
  SET_SORT_FIELD_ModeleSouscription,
  SET_ACTIF_ModeleSouscription,
  SET_CATEGORIE_ModeleSouscription,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModeleSouscription:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModeleSouscription:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModeleSouscription:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModeleSouscription:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModeleSouscription:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModeleSouscription:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModeleSouscription:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
